/** @jsx jsx */
import { jsx } from '@emotion/react';

import type { PageConfigComponent as PageConfigComponentTrackingData } from '@coursera/event-pulse-types';

import PillGroup from 'bundles/browse-common/components/Pill/PillGroup';
import SectionHeadingComponent from 'bundles/browse-common/components/SectionHeadingComponent';
import TrackedPill from 'bundles/browse-common/components/TrackedPill';
import type { Domain } from 'bundles/browse-common/types/domain';
import { usePageConfigComponentTrackingData } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import DomainIcon from 'bundles/unified-common/components/pill/DomainIcon';

type Props = {
  title: string;
  showPageTitleHeadingSize?: boolean;
  domains: Domain[];
};

const getTrackingData = (url: string, pageConfigComponentTrackingData?: PageConfigComponentTrackingData) => {
  return {
    button: {
      name: 'browse_domain' as const,
      linkType: 'internal' as const,
      linkURL: url,
      ...(pageConfigComponentTrackingData && { pageConfigComponent: pageConfigComponentTrackingData }),
    },
  };
};

const DomainListComponent = (props: Props) => {
  const { title, domains, showPageTitleHeadingSize = false } = props;
  const pageConfigComponentTrackingData = usePageConfigComponentTrackingData();

  return (
    <div data-testid="explore-categories">
      <SectionHeadingComponent showPageTitleHeadingSize={showPageTitleHeadingSize}>{title}</SectionHeadingComponent>
      <PillGroup dataTestId="category-pills-group">
        {domains.map((domain) => {
          const url = `/browse/${domain.slug}`;
          return (
            <TrackedPill
              key={domain.slug}
              href={url}
              trackingData={getTrackingData(url, pageConfigComponentTrackingData)}
              dataTestId={`category-pill-${domain.slug}`}
            >
              <DomainIcon domain={domain} />
              {domain.name}
            </TrackedPill>
          );
        })}
      </PillGroup>
    </div>
  );
};

export default DomainListComponent;
